module.exports = __webpack_public_path__ + "static/beholder_2-5efeddced82a5cde7ace08cba2e68e33.jpg";